<template>
    <a
        v-if="props.email"
        :href="`mailto:${decodedEmail}`"
    >
        <slot :email="decodedEmail" />
    </a>
</template>

<script setup lang="ts">
    import { computed } from 'vue';

    const props = defineProps<{
        email: string;
    }>();

    const decodedEmail = computed<string>(() =>
        // @ts-expect-error
        props.email?.toString().replace(/[a-zA-Z]/g, c => String.fromCharCode((c <= 'Z' ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26)));
</script>
